import React, { useEffect, useState } from 'react';
import Logo from '../../components/common/Logo';
import AdminSidebar from '../../components/admin/AdminSidebar';
import UserService from '../../services/user.service';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';


const AdminListUsersPage = () => {
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const { userType } = useParams();
    const navigate = useNavigate();
   
    useEffect(() => {
      loadUsers(userType);
    }, [userType]);

    const loadUsers = async (type) => {
        try {
          const data = await UserService.getUsersByRole();
          setUsers(type === 'doctors' ? data.therapists : data.patients);
        } catch (error) {
          console.error(`[DEBUG] Error loading ${type}:`, error);
        }
       };
   
    const filteredUsers = users.filter(user => 
      `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
   
    return (
      <div className="flex min-h-screen">
        <div className="w-64 bg-white shadow-md">
          <div className="p-4">
            <Logo />
          </div>
          <AdminSidebar />
        </div>
   
        <div className="flex-1 bg-gray-50 p-8">
          <header className="mb-8">
            <h1 className="text-2xl font-bold">
              {userType === 'doctors' ? 'Gestione Professionisti' : 'Gestione Pazienti'}
            </h1>
            {userType === 'doctors' && (
              <Link
                to="/admin/doctors/create"
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Nuovo Professionista
              </Link>
            )}
            
            {/* Search bar */}
            <div className="mt-4 relative">
              <input
                type="text"
                placeholder="Cerca per nome o email..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full p-3 pl-10 border rounded-lg"
              />
              <FontAwesomeIcon 
                icon={faMagnifyingGlass} 
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
              />
            </div>
          </header>
   
          {/* User cards in grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {filteredUsers.map((user) => (
              <div key={user.id} className="bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start">
                  <div>
                    <h2 className="font-semibold truncate">{user.first_name} {user.last_name}</h2>
                    <p className="text-sm text-gray-600 truncate">{user.email}</p>
                    <p className="text-sm text-gray-600">{user.phone}</p>
                    {userType === 'doctors' && 
                      <p className="text-sm text-gray-600 truncate">{user.specialization}</p>
                    }
                  </div>
                  <button
                    onClick={() => navigate(`/admin/${userType}/${user.id}`)}
                    className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
   };

   export default AdminListUsersPage;